module.exports = __webpack_public_path__ + "static/media/Sean Corriel.fbefdc91.png";